import { render } from "./task-card.vue?vue&type=template&id=279e054a&scoped=true"
import script from "./task-card.vue?vue&type=script&lang=js"
export * from "./task-card.vue?vue&type=script&lang=js"

import "./task-card.vue?vue&type=style&index=0&id=279e054a&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-279e054a"]])

export default __exports__